import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import { WATCHLIST_FRAGMENT } from './watchlist-fragment';

const QUERY = gql(
  `
  query getWatchlists {
    Watchlists {
      ...watchlistFields
      items {
        companyId
      }
    }
  }
`,
  [WATCHLIST_FRAGMENT]
);

export const queryFn = async () => {
  const response = await gqlClient.request(QUERY, {});

  if ('Watchlists' in response) {
    return response.Watchlists;
  }
};
